module.exports = __webpack_public_path__ + "static/media/friends_1.813e3881.png";